<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <!-- 物资类别 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资名称">
            <el-input
              v-model="queryParams.key_word"
              placeholder="请输入物资名称"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 入库时间 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="入库时间">
            <el-date-picker
              v-model="queryParams.inDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 按钮区域 -->
      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button :disabled="isExporting" @click="debouncedExportExcel">
          {{ isExporting ? "导出中..." : "导出" }}
        </el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <!-- 勾选列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="assetCatName" label="物资类别" />
      <el-table-column prop="fixedAssetName" label="物资名称" />
      <el-table-column prop="unitPrice" label="单价" />
      <el-table-column prop="dutyDeptName" label="归属部门" />
      <el-table-column prop="dutyPersonName" label="归属人" />
      <el-table-column prop="nationalAssetsCode" label="国资编码" />
      <el-table-column prop="applyPersonName" label="入库人" />
      <el-table-column prop="applyDate" label="入库时间" />
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
import { getInstoreLogList, getExcelInstoreLogList } from "@/api/material";
import { downloadFile, parseDateRange, debounce } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";

export default {
  name: "FixedMaterialTab",
  components: { PaginationBar },
  data() {
    return {
      isExporting: false, // 导出按钮的禁用状态
      queryParams: {
        key_word: "",
        inDateRange: [],
      },
      tableData: [],
      total: 0, // 总数据条数，实际应该通过 API 请求获取
      pageSize: 10, // 每页展示条数
      currentPage: 1, // 当前页
      selectedIds: [], // 存储勾选的 id 列表
      debouncedExportExcel: null, // 防抖后的导出方法
    };
  },
  created() {
    this.handleQuery();

    // 初始化防抖方法
    this.debouncedExportExcel = debounce(this.exportExcel.bind(this), 300);
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.logId); // 提取勾选行的 id
    },
    // 重置
    resetQuery() {
      this.queryParams = { key_word: "", inDateRange: [] };
      this.currentPage = 1;
      this.handleQuery();
    },
    handleQuery(page) {
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.inDateRange
      );
      this.currentPage = page || 1;
      getInstoreLogList({
        page_no: this.currentPage,
        page_size: this.pageSize,
        key_word: this.queryParams.key_word,
        begin_date,
        end_date,
      }).then((res) => {
        this.tableData = res.records || [];
        this.total = res.total;
      });
    },

    exportExcel() {
      if (!this.selectedIds.length) {
        // 提示请先勾选
        return this.$message.warning("请先勾选要导出的数据");
      }

      // 开始导出，禁用按钮
      this.isExporting = true;

      getExcelInstoreLogList(this.selectedIds)
        .then((res) => {
          downloadFile(
            res.data,
            "固定物资入库记录.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        })
        .catch((error) => {
          console.error("导出失败:", error);
          this.$message.error("导出失败，请稍后重试");
        })
        .finally(() => {
          // 导出完成，启用按钮
          this.isExporting = false;
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
